module.exports = __webpack_public_path__ + "static/img/shuju_bg.4d04641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/shuju_bg.png
// module id = VF8Q
// module chunks = 2